export default __webpack_public_path__ + "img/cdaae8480afacee6382496381eab30f2.svg";